define(
    'viewmodels/secured/people/tabs/persons/persons',[
        "viewmodels/controller",
        "durandal/app",
        "viewmodels/secured/people/context",
        "viewmodels/ViewModelNotification",
        "providers/dataprovider",
        "plugins/router",
        "i19n!i19n/strings",
        "services/service.dialog"
    ],
    function (shell, app, ctx, ViewModelNotification, dataProvider, router, i19n, dialogService) {

        var $grid = null;
        var grid = null;

        var vm = new ViewModelNotification(
        {
            i19n: i19n,
            $popup: null,
            $wnd: null,
            wnd: null,

            popupTemplate: null,

            accountForm: {
                id: '',
                emailaddress: ko.observable(''),
                password: ko.observable(''),
                passwordResetOption: ko.observable('email')
            },
            resultCount: ko.observable(0),
            usersinuser: ko.observable(),
            addRow: function () {
                if (grid) {
                    grid.addRow();
                }
            },
            listPersons: ko.observable(),
            listPersonTypes: ko.observable(),
            listPersonTypesAllowed: ko.observable(),
            listOrganisations: ko.observable(),
            listCultures: ko.observable(),
            listTeams: ko.observable(),

            tellReloadSubscription: null,

            isAdmin: ko.observable(false),
            isCustomerTrial: ko.observable(false),
            isInstanceAdmin: ko.observable(false)
        });

        ctx.tellReload.subscribe(function (n) {
            if (n == "person.organisation") {
                vm.refresh(true);
            }
            if (n == "person.team") {
                vm.refresh(true);
            }
        });

        vm.activate = function () {
            vm.isAdmin(vm.session.role == 3 || vm.session.role == 4 ? true : false);
            vm.isCustomerTrial(vm.session.isCustomerTrial == -1 ? true : vm.session.isCustomerTrial);
            vm.isInstanceAdmin(vm.session.role == 4 ? true : false);
        };
        vm.attached = function () {
            var self = this;

            self.$wnd = $("#persons-password-window");
            self.wnd = self.$wnd.kendoWindow({
                title: i19n.to.setpassword,
                modal: true,
                visible: false,
                resizable: false,
                width: 400,
                height: 200
            }).data('kendoWindow');

            $grid = $("#persons-grid");

            $("#person-search-input").off();
            $("#person-search-input").on("keyup", _.debounce(function () { filter.call(this, grid); }, 400));
            $("#person-search-input").val('');

            $(window).off("resize", _.debounce(resizeGrid, 250));
            $(window).on("resize", _.debounce(resizeGrid, 250));

            return self.loadData()
            .done(function () {

                var template = kendo.template($('#popup-people-editform').html());

                self.popupTemplate = template({
                    organisationDataSource: toKendoHtml(self.listOrganisations(), true),
                    cultureDataSource: toKendoHtml(self.listCultures(), true),
                    personTypeDataSource: toKendoHtml(self.listPersonTypes(), true),
                    teamDataSource: toKendoHtml(self.listTeams(), true)
                });
                
                buildKendoGrid();
            })
            .fail(function (e) {
                console.error(e);
            });

            function buildKendoGrid() {
                self.notifications([]);

                var columns = [
                    { field: "id", hidden: true },
                    { field: "displayName", title: i19n.to.displayname, width: 190 },
                    { field: "userName", title: i19n.to.username, width: 210 },
                    { field: "personType", title: i19n.to.role, values: self.listPersonTypes(), width: 160 },
                    { field: "organisationId", title: i19n.to.organisation, values: self.listOrganisations(), template: "#=organisation!==null && organisation.name !== undefined ? organisation.name : (organisationId !== null && organisationId.text !== undefined ? organisationId.text : '') #" }, //{ field: "organisation", title: i19n.to.organisation, width: 200, editor: organisationSelectEditor, template: "#=organisation!==null && organisation.name !== undefined?organisation.name:''#" },
                    { field: "phone", title: i19n.to.phone, width: 130 },

                    { field: "firstName", title: i19n.to.firstname, hidden: true },
                    { field: "lastName", title: i19n.to.lastname, hidden: true },
                    { field: "cultureCode", title: i19n.to.culture, hidden: true, width: 130, values: self.listCultures() },
                    { field: "emailAddress", title: i19n.to.emailaddress, hidden: true },
                    { field: "canEditListValues", title: i19n.to.caneditlistvalues, hidden: true },
                    { field: "teams", title: i19n.to.teams, hidden: true } //, template: teamMultiSelectEditorTemplate, editor: teamMultiSelectEditor }
                ];

                if (self.isAdmin()) {
                    var cmd = {
                        command: [
                            {
                                text: i19n.to.setpassword,
                                click: function (e) {
                                    e.preventDefault();

                                    var itm = this.dataItem($(e.currentTarget).closest("tr"));
                                    var org = itm.organisation != null ? itm.organisation : '';

                                    self.accountForm.id = itm.id;
                                    self.accountForm.emailaddress(itm.emailAddress);

                                    self.accountForm.password('');

                                    self.wnd.center().open();

                                    return false;
                                }
                            },
                            { name: "edit", text: i19n.to.edit },
                            { name: "destroy", text: i19n.to.delete }
                        ],
                        title: "&nbsp;",
                        width: 300
                    };

                    columns.push(cmd);
                }

                grid = $grid.kendoGrid({
                    dataSource: getKendoGridDataSource(),
                    resizable: true,
                    selectable: "row",
                    reorderable: true,
                    sortable: true,
                    columns: columns,
                    scrollable: {
                        virtual: true
                    },
                    editable: {
                        mode: "popup",
                        template: self.popupTemplate
                    },
                    cancel: self.clearNotifications,
                    edit: function (e) {
                        //var win = $(".k-edit-form-container").parent().width(600).height(600).data("kendoWindow").center();
                        var win = this.editable.element.data("kendoWindow").wrapper.css({ width: 500 });
                        var $selectedPersonType = e.container.find("select[name=personType] option:selected");
                        var tooltip = e.container.kendoTooltip({
                            content: kendo.template($("#people-form-role-template").html()),
                            filter: "i#role-help-text",
                            width: 400,
                            position: "right"
                        }).data("kendoTooltip");

                        e.container.find(".k-edit-label:first").hide();
                        e.container.find("input[name=id]").hide();
                        e.container.find("input[name=userName]").attr("readonly", true);

                        e.container.find("select[name=personType]").on("change", function () {
                            var $selected = e.container.find("select[name=personType] option:selected");
                            var cboPersonType = e.container.find("select[name=personType]").data("kendoDropDownList");
                            var q = undefined;

                            try {
                                q = _.findWhere(self.listPersonTypesAllowed(), { value: parseInt($selected.val()) });

                                if (!q || q === undefined) {
                                    cboPersonType.value(-1);

                                    toastr.error("The Role selected is not available as there are no available users. Please add more users to your fileplan subscription and try again.", i19n.to.error);

                                    return;
                                }

                            } catch (ex) {
                                console.error(ex);
                            }

                            setControlCanEditlistValues($selected.val());
                        });
                        e.container.find("input[name=emailAddress]").on("change", function () {
                            e.container.find("input[name=userName]").val(this.value);
                            e.container.find("input[name=userName]").trigger('change');
                        });

                        if (e.model.id.length == 0) {
                            $(".k-window-title").text(i19n.to.addperson);

                            e.container.find("input[name=firstName]").on("change", function () {
                                var f = this.value;
                                var l = e.container.find("input[name=lastName]").val();
                                var fullname = f + ' ' + l;
                                e.container.find("input[name=displayName]").val(fullname);
                                e.container.find("input[name=displayName]").trigger('change');
                            });
                            e.container.find("input[name=lastName]").on("change", function () {
                                var f = e.container.find("input[name=firstName]").val();
                                var l = this.value;
                                var fullname = f + ' ' + l;
                                e.container.find("input[name=displayName]").val(fullname);
                                e.container.find("input[name=displayName]").trigger('change');
                            });
                            e.container.find("input[name=emailAddress]").on("change", function () {
                                e.container.find("input[name=userName]").val(this.value);
                                e.container.find("input[name=userName]").trigger('change');
                            });

                        } else {
                            $(".k-window-title").text(i19n.to.editperson);
                        }

                        e.container.find(".k-edit-buttons").width(484);
                        e.container.find(".k-edit-buttons .k-grid-cancel").css({ "margin-right": 30 });
                        
                        setControlCanEditlistValues($selectedPersonType.val());

                        function setControlCanEditlistValues(selected) {
                            var ms = e.container.find("select[name=teams]").data("kendoMultiSelect");

                            //guest
                            if (selected == 1) {
                                e.container.find("input[name=canEditListValues]").prop('checked', false);
                                e.container.find("input[name=canEditListValues]").attr('disabled', true);

                                ms.dataSource.filter({ field: 'id', operator: 'eq', value: '60512100-d7dd-45d0-bcf3-1957dea2e56d' });
                            } else {
                                e.container.find("input[name=canEditListValues]").removeAttr('disabled');

                                ms.dataSource.filter(null);
                            }
                        }

                        self.clearNotifications();

                        //if (e.model.id.length == 0) {
                        //    var list = e.container.find("select[name=personType]").data("kendoDropDownList");
                            
                        //    var filters = _.map(self.listPersonTypesAllowed(), function (itm) {
                        //        return { field: "value", operator: "eq", value: itm.value };
                        //    });

                        //    list.dataSource.filter({
                        //        logic:"or",
                        //        filters: filters
                        //    });
                        //}
                    },
                    remove: self.clearNotifications,
                    save: self.clearNotifications

                }).data("kendoGrid");
            };
            function getKendoGridDataSource() {
                var schema = {
                    model: {
                        id: "id",
                        fields: {
                            id: { type: "string" },
                            displayName: { type: "string" },
                            cultureCode: { field: "cultureCode" },
                            userName: { type: "string" },
                            firstName: { type: "string" },
                            lastName: { type: "string" },
                            organisation: { field: "organisation" },
                            organisationId: { field: "organisationId" },
                            personType: { type: "string" },
                            canEditListValues: { type: "boolean" },
                            emailAddress: { type: "string" },
                            teams: {}
                        }
                    }
                };

                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            callbacks.success(self.listPersons());

                            setTimeout(function () {
                                resizeGrid();
                            }, 500);

                        },
                        update: function (callbacks) {
                            if (callbacks.data.organisation == null && callbacks.data.organisationId != null) {
                                callbacks.data.organisation = callbacks.data.organisationId;
                                callbacks.data.organisationId = callbacks.data.organisation.value;
                            }

                            //callbacks.data.cultureCode = callbacks.data.cultureCode.value;

                            dataProvider.persons
                            .updatePerson(callbacks.data)
                            .done(function (result) {
                                grid.refresh();

                                self.notify('success', callbacks.data.firstName + ' ' + callbacks.data.lastName + ' ' + i19n.to.updated);

                                callbacks.success();

                                ctx.tellReload("organisation.person");
                                ctx.tellReload("team.person");

                                vm.refresh(true);
                            })
                            .fail(function (result) {
                                result.stopPropagation = true;

                                self.notify(result.error);

                                callbacks.error(result.error);
                            });
                        },
                        create: function (callbacks) {
                            if (callbacks.data.organisation == null && callbacks.data.organisationId != null) {
                                callbacks.data.organisation = callbacks.data.organisationId;
                                callbacks.data.organisationId = callbacks.data.organisation.value;
                            }

                            dataProvider.persons
                            .addPerson(callbacks.data)
                            .done(function (result) {
                                grid.refresh();

                                self.notify('success', callbacks.data.firstName + ' ' + callbacks.data.lastName + ' ' + i19n.to.personadded);

                                callbacks.data["id"] = result;
                                callbacks.success(callbacks.data);

                                ctx.tellReload("organisation.person");
                                ctx.tellReload("team.person");

                                vm.refresh(true);
                            })
                            .fail(function (result) {
                                result.stopPropagation = true;

                                self.notify(result.error);

                                callbacks.error(result.error);
                            });
                        },
                        destroy: function (callbacks) {
                            var dialogoptions = { ok: { label: 'Yes', message: '' }, cancel: { label: 'No', message: '' } };

                            dialogService.showMessageBox(i19n.to.confirmdelete, i19n.to.delete + ' ' + callbacks.data.firstName + ' ' + callbacks.data.lastName + ' ' + ' ?', _.toArray(dialogoptions))
                            .then(function (action) {
                                if (action == dialogoptions.cancel) {
                                    grid.cancelChanges();
                                }
                                if (action == dialogoptions.ok) {
                                    shell.isBusy(true, "Processing", 10);

                                    dataProvider.persons
                                    .deletePerson(callbacks.data.id)
                                    .done(function (result) {
                                        grid.refresh();

                                        self.notify('success', i19n.to.persondeleted);

                                        callbacks.success();

                                        ctx.tellReload("organisation.person");
                                        ctx.tellReload("team.person");

                                        vm.refresh(true);
                                    })
                                    .fail(function (e) {
                                        grid.cancelChanges();

                                        e.stopPropagation = true;

                                        self.notify(e.error);

                                        callbacks.error(e.error);

                                        console.error(e);
                                    })
                                    .always(function () {
                                        shell.isBusy(false);
                                    });
                                }
                            });
                        }
                    },
                    schema: schema,
                    pageSize: 999
                });
            }

            //#region commented
            //function getKendoOrganisationDataSource() {
            //    return new kendo.data.DataSource({
            //        transport: {
            //            read: function (callbacks) {
            //                callbacks.success(self.listOrganisations());
            //            }
            //        },
            //        schema: {
            //            model: {
            //                id: "value",
            //                fields: {
            //                    value: { type: "string" },
            //                    text: { type: "string" }
            //                }
            //            }
            //        }
            //    });
            //}
            //function teamMultiSelectEditorTemplate(data) {
            //    var list = [];
            //    $.each(data.teams, function (i, el) {
            //        list.push(el.id);
            //    });                
            //    return list.join(',');
            //}
            //function teamMultiSelectEditor(container, options) {
            //    $("<select multiple='multiple' data-bind='value: teams'/>")
            //    .appendTo(container)
            //    .kendoMultiSelect({
            //        dataTextField: "text",
            //        dataValueField: "id",
            //        dataSource: getKendoDataSource()
            //    });

            //    function getKendoDataSource() {
            //        return new kendo.data.DataSource({
            //            transport: {
            //                read: function (callbacks) {
            //                    callbacks.success(self.listTeams());
            //                }
            //            },
            //            schema: {
            //                model: {
            //                    id: "id",
            //                    fields: {
            //                        id: { type: "string" },
            //                        text: { type: "string" }
            //                    }
            //                }
            //            }
            //        });
            //    }
            //}
            //function organisationSelectEditor(container) {
            //    var dl = container;
            //    console.warn(dl.data("dropdownlist"));

            //    //$('<select />' +
            //    //    'data-source="[{&quot;text&quot;:&quot; &quot;,&quot;value&quot;:&quot; &quot;},{&quot;text&quot;:&quot;Freds Flowers&quot;,&quot;value&quot;:&quot;ca491696-1db3-430a-a511-1e7c63414f30&quot;},{&quot;text&quot;:&quot;Google&quot;,&quot;value&quot;:&quot;6173d671-a806-4b17-8cf7-558945491909&quot;}]')
            //    //.appendTo(container)
            //    //.kendoDropDownList({
            //    //    dataTextField:"text",
            //    //    dataValueField:"value",
            //    //    dataRole:"dropdownlist",
            //    //    name:"organisationId",
            //    //    dataBind:"value:organisationId",
            //    //    dataSource: getKendoDataSource()
            //    //});

            //    function getKendoDataSource() {
            //        return new kendo.data.DataSource({
            //            transport: {
            //                read: function (callbacks) {
            //                    callbacks.success(self.listOrganisations());
            //                }
            //            },
            //            schema: {
            //                model: {
            //                    id: "value",
            //                    fields: {
            //                        value: { type: "string" },
            //                        text: { type: "string" }
            //                    }
            //                }
            //            }
            //        });
            //    }
            //};
            //#endregion

            function resizeGrid() {
                if (!grid)
                    return;

                var tbh = $("#persons-grid-toolbar", "#content-persons").outerHeight(); tbh = tbh == 0 ? 51 : tbh;
                var h = $("#content-people").outerHeight()
                    - $(".page-header", "#content-people").outerHeight()
                    - tbh
                    - 110;

                $grid.height(h);
                grid.resize();
            }
        };
        vm.refresh = function (newValue) {
            var self = this;

            if (grid == null)
                return;

            if (newValue) {
                self.loadData()
                .done(function () {
                    var col = _.findWhere(grid.columns, { field: "organisationId" });

                    col.values = self.listOrganisations();

                    var template = kendo.template($('#popup-people-editform').html());

                    self.popupTemplate = template({
                        organisationDataSource: toKendoHtml(self.listOrganisations(), true),
                        cultureDataSource: toKendoHtml(self.listCultures(), true),
                        personTypeDataSource: toKendoHtml(self.listPersonTypes(), true),
                        teamDataSource: toKendoHtml(self.listTeams(), true)
                    });

                    grid.setOptions({
                        editable: {
                            mode: "popup",
                            template: self.popupTemplate
                        }
                    });

                    grid.dataSource.read();
                })
                .fail(function (e) {
                    console.error(e);
                });
            }
        };
        vm.isBusy = ko.computed(function () {
            return false;
        });
        vm.loadData = function () {
            var self = this;
            var d = $.Deferred();

            ctx.loadForPerson()
            .done(function () {
                var personTypes = $.map(ctx.personTypes(), function (itm) {
                    return { text: itm.label, value: itm.personTypeId };
                });
                var organisations = $.map(ctx.organisations(), function (itm) {
                    return { text: itm.name, value: itm.id };
                });
                var teams = $.map(ctx.teams(), function (itm) {
                    return { text: itm.name, id: itm.id };
                });
                var cultures = $.map(ctx.cultures(), function (itm) {
                    return { text: itm.specificCulture, value: itm.cultureCode };
                });

                organisations.unshift({ text: ' ', value: null });

                self.listPersonTypes(personTypes);
                self.listPersonTypesAllowed(personTypes);
                self.listOrganisations(organisations);
                self.listTeams(teams);
                self.listPersons(ctx.persons());
                self.listCultures(cultures);

                self.resultCount(self.listPersons().length);

                var psum = { activeGuest: 0, activeUsers: 0 };
                _.map(self.listPersons(), function (itm) {
                    if (itm.personType == 1) {
                        psum.activeGuest++;
                    }
                    if (itm.personType != 1 && itm.personType != 0) {
                        psum.activeUsers++;
                    }
                });

                if (vm.isCustomerTrial())
                    vm.usersinuser(String.format(i19n.to._usersinuse_guestsinuse, psum.activeUsers, psum.activeGuest));
                else
                    vm.usersinuser(String.format(i19n.to._usersinuseof_available, psum.activeUsers, "_", psum.activeGuest, "_"));

                dataProvider.subscription
                .getCustomerSubs()
                .done(function (data) {
                    if (vm.isCustomerTrial())
                        vm.usersinuser(String.format(i19n.to._usersinuse_guestsinuse, psum.activeUsers, psum.activeGuest));
                    else
                        vm.usersinuser(String.format(i19n.to._usersinuseof_available, psum.activeUsers, data.subsMaxUserCount, psum.activeGuest, data.subsMaxGuestCount));

                    var g = _.filter(vm.listPersonTypes(), function (itm) {
                        if (psum.activeGuest >= data.subsMaxGuestCount || psum.activeUsers >= data.subsMaxUserCount) {
                            if (psum.activeGuest >= data.subsMaxGuestCount && psum.activeUsers >= data.subsMaxUserCount) {
                                return itm.value == 0;
                            }
                            if (psum.activeGuest < data.subsMaxGuestCount && psum.activeUsers >= data.subsMaxUserCount) {
                                return itm.value == 0 || itm.value == 1;
                            }

                            return false;
                        }
                        return true;
                    });
                    
                    self.listPersonTypesAllowed(g);
                })
                .fail(function (e) {
                    e.stopPropagation = true;

                    console.error(e);
                })
                .always(function () {
                    d.resolve();
                });
            })
            .fail(function (e) {
                d.reject('error loading in person module : ' + e);
                console.error('error loading in person module : ' + e);
            });

            return d.promise();
        };
        vm.saveClick = function () {
            var self = this;

            if (self.accountForm.passwordResetOption() == 'email') {
                var data = { email: self.accountForm.emailaddress() };

                var url = window.location.href.toString();
                url = url.replace('#login', '#reset/id=');

                dataProvider.accounts
                .sendResetPasswordLink(data.email, url)
                .done(function () {
                    self.notify('success', i19n.to.resetpasswordemailsent);
                    self.wnd.close();
                })
                .fail(function (e) {
                    e.stopPropagation = true;

                    self.notify(e.error);
                    self.wnd.close();
                });

            } else {
                var data = { id: self.accountForm.id, password: self.accountForm.password() };

                dataProvider.persons
                .updatePersonPassword(data)
                .done(function (result) {
                    if (self.accountForm.firstname)
                        self.notify('success', self.accountForm.firstname() + ' ' + self.accountForm.lastname() + ' ' + i19n.to.updated);
                    else
                        self.notify('success', 'Record ' + i19n.to.updated);

                    self.wnd.close();
                })
                .fail(function (e) {
                    e.stopPropagation = true;

                    self.notify(e.error);
                    self.wnd.close();
                });

            }
            return false;
        };
        vm.cancelClick = function () {
            var self = this;

            self.wnd.close();

            return false;
        };
        vm.clickManageSubscription = function () {
            //var url = window.location.origin + window.location.pathname + "#plan/1";

            //window.open(url, "_blank");

            sessionStorage.navto = "people";

            //router.navigate("#plan/1");

            dataProvider.subscription
            .getCustomerSubs()
            .done(function (subs) {
                var isCustomerTrial = vm.session.isCustomerTrial == -1 ? true : vm.session.isCustomerTrial;
                var isOldClient = subs.subsPlanCode == "fileplan_starter_aud" && !isCustomerTrial;
                
                if (isOldClient)
                    router.navigate("#plan/1");
                else
                    router.navigate("#pricing/1");
            })
            .fail(function (e) {
                console.error(e);

                e.stopPropagation = true;
            });

            return false;
        };

        return vm;

        function filter(kendoGrid) {
            if (!kendoGrid)
                return;

            var value = this.value;

            var filteredColumns = _.filter(kendoGrid.options.columns, function (column) { return !column.hidden; });
            //var filteredColumns = [{ field: "displayName" }, { field: "userName" }, { field: "personType" }, { field: "organisationId" }, { field: "phone" }];
            var filters = _.map(filteredColumns, function (column) {
                return {
                    field: column.field,
                    operator: function (item, val) {

                        if (!(typeof column.command == 'undefined'))
                            return false;

                        if (val == null || val.trim().length == 0)
                            return true;

                        var searchText = '';

                        if (item != null) {
                            searchText = item.toString();

                            if (column.field == "personType") {
                                var s = _.findWhere(column.values, { value: parseInt(item) });
                                searchText = s == null ? '' : s.text.toString();
                            }
                            if (column.field == "organisationId") {
                                var s = _.findWhere(column.values, { value: item });
                                searchText = s == null ? '' : s.text.toString();
                            }
                        }

                        val = val.toLowerCase();
                        searchText = searchText.toLowerCase();

                        return item != null && searchText.indexOf(val) >= 0;

                    }, value: value //String.format("'{0}'", value)
                };
            });

            kendoGrid.dataSource.filter({
                logic: "or",
                filters: filters
            });
        }

        //put this somewhere in global
        function toKendoHtml(data, json) {
            if (json) if (data.length > 0) data = JSON.stringify(data);
            return _.escape(data).replace("#", "\\#");
        }
    });


